import { FC, useState } from "react";
import {
  Box,
  CardHeader,
  CircularProgress,
  IconButton,
  CardContent,
} from "@mui/material";
import { FiX } from "react-icons/fi";
import { useScreenSize } from "../../hooks/useScreenSize";

interface Props {
  open: boolean;
  onClose: () => void;
  paymentURL: string;
}

export const OnlinePaymentMain: FC<Props> = ({ open, onClose, paymentURL }) => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <CardHeader
        title="PAYMENT"
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 700 }}
        action={
          <IconButton onClick={onClose} size="small">
            <FiX />
          </IconButton>
        }
      />
      <CardContent sx={{ height: { xs: "100vh", lg: "80vh" } }}>
        {loading && (
          <Box
            sx={{ width: "100%", height: "100%" }}
            display="flex"
            alignItems="center"
            justifyContent="center">
            <CircularProgress size={50} />
          </Box>
        )}
        <iframe
          width="100%"
          height="100%"
          src={paymentURL}
          onLoad={() => setLoading(false)}
          frameBorder={0}
          allowFullScreen></iframe>
      </CardContent>
    </>
  );
};
